<template>
    <b-container fluid class="img-bg">
        <b-row no-gutters>
            <b-col sm class="header-column">
                <AdminBar title="Napoli Sotterranea Tour"></AdminBar>
            </b-col>
        </b-row>
        <b-row no-gutters class="mainrow">
            <b-col xl="1" class="d-none d-xl-block">
            </b-col>
            <b-col xl="7" lg="8" md="12" >
                <div class="panel tourbox">
                    <Calendar ref="calendar_view" :locale="active_language" @event-click="selectEvent" @day-click="selectDay"></Calendar>
                </div>
            </b-col>
            <b-col xl="3" lg="4" md="12">
                <div class="panel">
                    <event-form ref="eventform" v-on:add-event="addEvent"></event-form>
                </div>
                <div class="panel">
                    <EventCard :tour_prop="selected_tour" @host="startHosting" :lang="active_language"></EventCard>
                </div>
            </b-col>
            <b-col xl="1" class="d-none d-xl-block">
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import AdminBar from "./AdminBar";
    import Calendar from './Calendar'
    import EventForm from "./EventForm";
    import EventCard from "./EventCard";

    export default {
        name: "adminhome",
        data () {
            return {
                unsubscribe_listener: null,
                tour_duration: 40,
                fcEvents : [],
                selected_tour: null,
                selected_event: null,
                selected_day: null,
                active_language: 'EN'
            }
        },
        components: {
            AdminBar,
            EventForm,
            EventCard,
            Calendar
        },
        computed: {
            tour_duration_in_sec() {
                return this.tour_duration * 60;
            }
        },
        methods:{
            startHosting: function() {
                // this.$router.push('/host/' + this.selected_tour.id);
                let routeData = this.$router.resolve({name: 'host_tour', params: { channel: this.selected_tour.id } });
                window.open(routeData.href, '_blank');
            },
            selectDay: function (day) {
                this.$refs.eventform.setDate(day);
                day.setHours(10);
                day.setMinutes(0);
                this.$refs.eventform.setTime(day);
            },
            selectEvent: function(event) {
                this.selected_tour = event;
            },
            addEvent: function (_event_form_data){

                let date_time = new Date(_event_form_data.date + ' ' + _event_form_data.time);
                /*let event_data = {
                    occupancy: _event_form_data.occupancy,
                    available_seats: _event_form_data.occupancy,
                    tour: _event_form_data.tour,
                }*/

                let fs_date_time = this.$firebase.firebase.firestore.Timestamp.fromMillis(date_time.valueOf());
                let fs_date_time_end = this.$firebase.firebase.firestore.Timestamp.fromMillis(date_time.valueOf() + (this.tour_duration_in_sec * 1000));
                let storeEvent = {
                   start: fs_date_time,
                   end: fs_date_time_end,
                   occupancy: _event_form_data.occupancy,
                   available_seats: _event_form_data.occupancy,
                   tour: _event_form_data.tour,
                }

                this.$firebase.eventsCollection.add(storeEvent)
                    .catch(function(error) {
                       console.error("Error adding document: ", error);
                    });
            },
        },
        mounted() {
            this.$nextTick(() => {
                this.unsubscribe_listener = this.$firebase.eventsCollection.onSnapshot(function (querySnapshot) {
                    this.$refs.calendar_view.addEventsFromSnapshot(querySnapshot);
                }.bind(this));
            })
        },
        beforeDestroy() {
            this.unsubscribe_listener();
        }
    }
</script>

<style scoped>

    .header-column{
        margin-top:1.5%;
        margin-bottom:1.5%;
    }

    .img-bg{
        background-image: url("../../public/ns_bg.jpg");
        background-size: cover;
        background-position: center;
        padding:0;
        height:100%;
        overflow:auto;
    }

    .mainrow{
        min-height:85%;
        padding: 0 10px 0 10px;
    }

    .panel{
        background-color:#fff;
        margin:3px;
        padding:5px;
        border-radius:5px;
    }

    .tourbox{
        border: 5px solid transparent;
        outline: 1px solid #000;
        outline-offset: -5px;
    }

    @media screen and (max-width: 992px) {
        .header-column{
            margin-top:0;
            margin-bottom:5px;
        }

        .mainrow{
            height:50%;
            padding:0;
        }
    }

</style>
